import React from 'react';

const PadLock: React.FC = () => {
  return (
    <div className="float-right input-icon pad-lock-input-icon">
      <svg
        width="12"
        height="16"
        viewBox="0 0 12 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="checkout-panel-form-input-icon-color "
          d="M8.06752 5.10603V3.6423C8.06752 3.02957 7.84626 2.50196 7.40374 2.05943C6.96121 1.61691 6.4336 1.39565 5.82087 1.39565C5.20814 1.39565 4.68053 1.61691 4.238 2.05943C3.79548 2.50196 3.57422 3.02957 3.57422 3.6423V5.10603H8.06752ZM4.79966 11.1992C5.09468 11.4942 5.43508 11.6417 5.82087 11.6417C6.20666 11.6417 6.54706 11.4942 6.84208 11.1992C7.13709 10.9042 7.2846 10.5638 7.2846 10.178C7.2846 9.79222 7.13709 9.45183 6.84208 9.15681C6.54706 8.86179 6.20666 8.71429 5.82087 8.71429C5.43508 8.71429 5.09468 8.86179 4.79966 9.15681C4.50465 9.45183 4.35714 9.79222 4.35714 10.178C4.35714 10.5638 4.50465 10.9042 4.79966 11.1992ZM10.178 5.10603C10.5638 5.10603 10.9042 5.24786 11.1992 5.53153C11.4942 5.8152 11.6417 6.14992 11.6417 6.53571V13.8203C11.6417 14.2061 11.4942 14.5408 11.1992 14.8245C10.9042 15.1082 10.5638 15.25 10.178 15.25H1.46373C1.07794 15.25 0.737539 15.1082 0.442522 14.8245C0.147506 14.5408 0 14.2061 0 13.8203V6.53571C0 6.14992 0.147506 5.8152 0.442522 5.53153C0.737539 5.24786 1.07794 5.10603 1.46373 5.10603H2.17857V3.6423C2.17857 2.64378 2.53599 1.78711 3.25084 1.07227C3.96568 0.357418 4.82235 0 5.82087 0C6.81939 0 7.67606 0.357418 8.3909 1.07227C9.10575 1.78711 9.46317 2.64378 9.46317 3.6423V5.10603H10.178Z"
        />
      </svg>
    </div>
  );
};

export default PadLock;
